export default __webpack_public_path__ + "static/7-5ffc3311a22f9736c51dd4c999f2bdae.png";